<template>
  <v-app>
    <v-navigation-drawer
      app
      color="primary"
    >
    </v-navigation-drawer>
    <v-main class="derecha">
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
          >
            <v-card
              class="elevation-3"
              tile
            >
              <v-card-title>
                Registre su nueva contraseña
              </v-card-title>
              <v-form
                @submit.prevent="resetPassword"
              >
              <v-card-text>
                    <h4>
                        Usted ha solicitado cambio de contraseña, completar las sigte. Información.
                    </h4>
                <v-text-field
                  v-model="form.password"
                  label="Nueva contraseña"
                  name="password"
                  append-icon="mdi-at"
                  type="password"
                  :error-messages="errorsPassword"
                  @blur="$v.form.password.$touch()"
                  :hide-details="!$v.form.password.$error"
                />
                <v-text-field
                  v-model="form.repeatPassword"
                  label="Confirmar contraseña"
                  name="password"
                  append-icon="mdi-lock"
                  type="password"
                  :error-messages="errorsRepeatPassword"
                  @blur="$v.form.repeatPassword.$touch()"
                  @focus="removeServerError('new_password2')"
                  :hide-details="!$v.form.repeatPassword.$error &&
                    !this.serverErrors.new_password2"
                />

                <v-btn
                  name="submit"
                  type="submit"
                  outlined
                  class="my-5"
                  block
                >
                  Resetear contraseña
                </v-btn>
              </v-card-text>
                </v-form>
                <v-col
                cols="12"
                sm="8"
                >
                <router-link :to="{ name: 'Login' }">
                      Volver al login
                </router-link>
              </v-col>

            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import types from '@/types';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      form: {
        uid: this.$route.params.uid,
        token: this.$route.params.token,
        password: '',
        repeatPassword: '',
      },
      serverErrors: {},
    };
  },

  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8),
      },
      repeatPassword: {
        required,
        sameAs: sameAs('password'),
      },
    },
  },

  computed: {
    errorsPassword() {
      const errors = [];
      if (!this.$v.form.password.$dirty) { return errors; }
      if (!this.$v.form.password.required) {
        errors.push('Introduzca la contraseña.');
      }
      if (!this.$v.form.password.minLength) {
        errors.push('La contraseña debe contener minimo 8 caracteres');
      }
      return errors;
    },
    errorsRepeatPassword() {
      const errors = [];
      if (!this.$v.form.repeatPassword.$dirty) { return errors; }
      if (!this.$v.form.repeatPassword.required) {
        errors.push('Confirm your password.');
      }
      if (!this.$v.form.repeatPassword.sameAs) {
        errors.push('Password must match.');
      }
      if (this.serverErrors.new_password2) {
        errors.push(this.serverErrors.new_password2.toString());
      }
      return errors;
    },
  },

  methods: {
    ...mapMutations({
      [types.SHOW_BUSY]: `${types.APP}/${types.SHOW_BUSY}`,
      [types.HIDE_BUSY]: `${types.APP}/${types.HIDE_BUSY}`,
      [types.SHOW_SUCCESS]: `${types.APP}/${types.SHOW_SUCCESS}`,
      [types.SHOW_WARNING]: `${types.APP}/${types.SHOW_WARNING}`,
    }),
    ...mapActions({
      [types.RESET_PASSWORD]: `${types.USER}/${types.RESET_PASSWORD}`,
    }),

    resetPassword() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      this[types.SHOW_BUSY]('Setting password...');
      this[types.RESET_PASSWORD](this.form)
        .then(() => {
          this[types.SHOW_SUCCESS]('Cambio de contraseña finalizado, puede iniciar sessión ahora');
          setTimeout(() => {
            this.$router.push({ name: 'Login' });
          }, 500);
        })
        .catch((error) => {
          let errorMessage;
          if (error.response && error.response.data) {
            this.serverErrors = error.response.data;
          }
          if ('token' in this.serverErrors || 'uid' in this.serverErrors) {
            errorMessage = 'Hay algo mal al restablecer su contraseña, el enlace puede estar vencido o ya se usa.';
          }
          if (errorMessage) {
            this[types.SHOW_WARNING](errorMessage);
          }
        })
        .finally(() => {
          this[types.HIDE_BUSY]();
        });
    },
    removeServerError(field) {
      delete this.serverErrors[field];
    },
  },
  mounted() {
    this[types.LOGOUT]();
  },
};
</script>

<style>
.derecha {
  background-color: rgb(156, 153, 153);
}
</style>



// WEBPACK FOOTER //
// src/views/user/ResetPassword.vue